<template>
  <div class="d-flex flex-column">
    <div class="d-flex flex-column flex-md-row">
      <v-text-field
        v-model="full_name"
        label="Nome"
        :disabled="!editMode || loading"
        class="mr-2"
      />
      <v-text-field
        :value="maintainer.institution_code + '-' + maintainer.login"
        label="Login"
        disabled
        class="mr-2"
      />
      <v-switch
        v-model="status"
        :disabled="!editMode || loading"
        class="ma-2"
        :label="status ? 'Ativo' : 'Inativo'"
      />
      <v-btn
        :disabled="loading"
        filled
        class="mt-1"
        depressed
        large
        @click="editMode = !editMode"
      >
        <v-icon left>
          mdi-pencil
        </v-icon> {{ editMode ? 'Cancelar' : 'Editar' }}
      </v-btn>
    </div>
    <div
      v-if="editMode"
      class="d-flex flex-column flex-md-row justify-space-between my-8"
    >
      <v-btn
        :disabled="loading"
        filled
        class="mt-1"
        large
        depressed
        @click="confirmDelete"
      >
        <v-icon
          left
          color="red"
        >
          mdi-delete
        </v-icon> Apagar usuário
      </v-btn>
      <v-btn
        :disabled="loading"
        filled
        class="mt-1"
        depressed
        large
        @click="confirmNewPass"
      >
        <v-icon left>
          mdi-lock-plus
        </v-icon> Gerar Nova senha
      </v-btn>
      <v-btn
        :disabled="loading"
        filled
        class="mt-1 text-success"
        depressed
        large
        @click="updateMaintainer"
      >
        <v-icon
          left
          color="success"
        >
          mdi-arrow-up-bold-box-outline
        </v-icon> Atualizar
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    maintainer: { type: Object, default: undefined }
  },

  data: () => ({
    editMode: false,
    loading: false,
    status: false,
    full_name: ''
  }),
  watch: {
    editMode (newVal) {
      if (!newVal) {
        this.full_name = this.maintainer.full_name
        this.status = this.maintainer.status
      }
    },
    maintainer () {
      this.full_name = this.maintainer.full_name
      this.status = this.maintainer.status
    }
  },
  created () {
    this.full_name = this.maintainer.full_name
    this.status = this.maintainer.status
  },
  methods: {
    async confirmNewPass () {
      this.$dialog.confirm('Gerar nova senha temporária')
        .text('Tem certeza que deseja gerar uma nova senha para este usuário ?')
        .label('Nova senha')
        .onConfirm(async () => {
          await this.generatePassword(this.maintainer.id)
        })
        .show()
    },
    async generatePassword (id) {
      this.loading = true
      try {
        const response = await this.$api.generatePassword(id)
        this.$dialog.confirm(`Nova senha do ${response.user.short_name}`)
          .text(`${response.new_password}`)
          .show()
        this.loading = false
      } catch (e) {
        this.loading = false
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível gerar a senha, tente novamente mais tarde.', color: 'red' })
      } finally {
        this.loading = false
        this.editMode = false
        this.$emit('reload')
      }
    },

    async confirmDelete () {
      this.$dialog.confirm('Apagar mantenedor?')
        .text('Tem certeza que deseja apagar este usuário ? não será possível reverter')
        .label('Apagar')
        .onConfirm(async () => {
          await this.deleteMaintainer(this.maintainer.id)
        })
        .show()
    },

    async deleteMaintainer (id) {
      this.loading = true
      try {
        await this.$api.deleteMaintainer(id)
        this.$store.dispatch('setSnackBar', { text: 'Usuário apagado com sucesso.' })
      } catch (e) {
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível apagar o usuário, tente novamente mais tarde.', color: 'red' })
      } finally {
        this.loading = false
        this.editMode = false
        this.$emit('reload')
      }
    },
    async updateMaintainer () {
      this.loading = true
      const data = {
        full_name: this.full_name,
        status: this.status ? 1 : 0
      }
      try {
        await this.$api.updateMaintainer(this.maintainer.id, data)
        this.$store.dispatch('setSnackBar', { text: 'Atualizado com sucesso.' })
      } catch (e) {
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível atualizar, tente novamente mais tarde.', color: 'red' })
      } finally {
        this.loading = false
        this.editMode = false
        this.$emit('reload')
      }
    }
  }
}
</script>
